import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'userRoles.list.actions': {
    defaultMessage: 'Actions',
    id: 'userRoles.list.actions'
  },
  'userRoles.list.actions.disable.areYouSure': {
    defaultMessage: 'Are you sure you want to disable the role "<b>{displayName}</b>"?',
    id: 'userRoles.list.actions.disable.areYouSure'
  },
  'userRoles.list.actions.disable.areYouSure.description': {
    defaultMessage: 'This will prevent the role from being added to any new checks or users, but will <b>not</b>'
      + ' remove the role from any checks or users it has already been added to.',
    id: 'userRoles.list.actions.disable.areYouSure.description'
  },
  'userRoles.list.actions.disable.modalTitle': {
    defaultMessage: 'Disable User-Defined Role?',
    id: 'userRoles.list.actions.disable.modalTitle'
  },
  'userRoles.list.actions.enable.areYouSure': {
    defaultMessage: 'Are you sure you want to enable the role "<b>{displayName}</b>"?',
    id: 'userRoles.list.actions.enable.areYouSure'
  },
  'userRoles.list.actions.enable.modalTitle': {
    defaultMessage: 'Enable User-Defined Role?',
    id: 'userRoles.list.actions.enable.modalTitle'
  },
  'userRoles.list.active': {
    defaultMessage: 'Active',
    id: 'userRoles.list.active'
  },
  'userRoles.list.description': {
    defaultMessage: 'Description',
    id: 'userRoles.list.description'
  },
  'userRoles.list.disable': {
    defaultMessage: 'Disable',
    id: 'userRoles.list.disable'
  },
  'userRoles.list.disable.failure': {
    defaultMessage: 'Failed to disable user-defined role',
    id: 'userRoles.list.disable.failure'
  },
  'userRoles.list.disable.success': {
    defaultMessage: 'User-Defined role disabled successfully',
    id: 'userRoles.list.disable.success'
  },
  'userRoles.list.displayedRows': {
    defaultMessage: '{from, number}-{to, plural, =-1 {{count, number}} other {#}} of {count, plural, =-1 {more than {to, number}} other {#}}',
    id: 'userRoles.list.displayedRows'
  },
  'userRoles.list.empty.action': {
    defaultMessage: 'Create a role',
    id: 'userRoles.list.empty.action'
  },
  'userRoles.list.empty.primary': {
    defaultMessage: 'No user-defined roles',
    id: 'userRoles.list.empty.primary'
  },
  'userRoles.list.empty.secondary': {
    defaultMessage: 'Your account has no user-defined roles yet.',
    id: 'userRoles.list.empty.secondary'
  },
  'userRoles.list.enable': {
    defaultMessage: 'Enable',
    id: 'userRoles.list.enable'
  },
  'userRoles.list.enable.failure': {
    defaultMessage: 'Failed to enable user-defined role',
    id: 'userRoles.list.enable.failure'
  },
  'userRoles.list.enable.success': {
    defaultMessage: 'User-Defined role enabled successfully',
    id: 'userRoles.list.enable.success'
  },
  'userRoles.list.inactive': {
    defaultMessage: 'Inactive',
    id: 'userRoles.list.inactive'
  },
  'userRoles.list.inactive.tooltip': {
    defaultMessage: 'This role might still be present on checks or users it has already been added to,'
      + ' but it cannot be added to any new checks or users.',
    id: 'userRoles.list.inactive.tooltip'
  },
  'userRoles.list.loading': {
    defaultMessage: 'Loading...',
    id: 'userRoles.list.loading'
  },
  'userRoles.list.name': {
    defaultMessage: 'Name',
    id: 'userRoles.list.name'
  },
  'userRoles.list.rowsPerPage': {
    defaultMessage: 'Rows per page',
    id: 'userRoles.list.rowsPerPage'
  },
  'userRoles.list.status': {
    defaultMessage: 'Status',
    id: 'userRoles.list.status'
  },
  'userRoles.list.update': {
    defaultMessage: 'Update',
    id: 'userRoles.list.update'
  }
});
